<div class="extra-item" [ngClass]="{selected: this.modifier.selectedQuantity}">
    <span class="extra-name">{{modifier.name}}</span>
    <div class="extra-right">
        <span class="extra-price">
            {{modifier.calculatedPrice | currency:('CURRENCY_SYMBOL' | translate):('CURRENCY_SIGN' | translate)}}
        </span>

        <div class="extra-buttons extra-checkbox" [class.extra-checkbox-disabled]="groupIsMaxFull">
            <mat-checkbox
                    [(ngModel)]="checked"
                    [checked]="checked"
                    [disabled]="groupIsMaxFull && !checked"
                    (change)="checkboxChange($event.checked)">
            </mat-checkbox>
        </div>
    </div>
</div>
